import React from 'react';
import PropTypes from 'prop-types';
import { FlightTicketPropType } from '../../../../PropTypes';
import { Form, Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import NTAN from '../NTAN';

const parseBooleanOrNull = (value) => {
  if (value === 'true' || value === true) return true;
  if (value === 'false' || value === false) return false;
  return null;
};

const AdditionalOptionsSection = ({
  flyToWorkTicketInfo,
  setFlyToWorkTicketInfo,
  mappedStaffLuggage,
  handleUpdateFlightTicketInfo,
  isOSFieldDisabled,
  isOSFieldDisabledNoTravelNeeded,
  isArrivalDepartureAirportDisabled,
  isGreenLightCheckBoxDisabled,
  darkMode,
  getReactSelectStyles,
}) => (
  <Row>
    <Form.Group as={Col}>
      <Row>
        <Col>
          <Form.Check
            inline
            label="Hotel Needed"
            name="is_hotel_needed_checkbox"
            type="checkbox"
            id="hotelNeeded_checkbox"
            value="isHotelNeeded"
            checked={parseBooleanOrNull(flyToWorkTicketInfo.isHotelNeeded)}
            onChange={(e) => handleUpdateFlightTicketInfo('isHotelNeeded', e.target.checked)}
            disabled={isOSFieldDisabled()}
          />
        </Col>
        <Col>
          <Form.Check
            inline
            label="Book Return Flight"
            name="is_book_return_flight_checkbox"
            type="checkbox"
            id="isBookReturnFlight_checkbox"
            value="isBookReturnFlight"
            checked={parseBooleanOrNull(flyToWorkTicketInfo.isBookReturnFlight)}
            onChange={(e) => {
              handleUpdateFlightTicketInfo('isBookReturnFlight', e.target.checked);
              if (!e.target.checked) {
                handleUpdateFlightTicketInfo('brfReturnFlightDate', null);
                handleUpdateFlightTicketInfo('brfDepartureAirport', null);
                handleUpdateFlightTicketInfo('brfArrivalAirport', null);
              }
            }}
            disabled={isOSFieldDisabled()}
          />
        </Col>
        <Col>
          <Form.Check
            inline
            label="Train ticket"
            name="is_rail_and_fly_checkbox"
            type="checkbox"
            id="isRailAndFly_checkbox"
            value="isRailAndFly"
            checked={parseBooleanOrNull(flyToWorkTicketInfo.isRailAndFly)}
            onChange={(e) => {
              handleUpdateFlightTicketInfo('isRailAndFly', e.target.checked);
              if (!e.target.checked) {
                handleUpdateFlightTicketInfo('homeTrainStationName', null);
              }
            }}
            disabled={isOSFieldDisabled()}
          />
        </Col>
        <Col>
          <NTAN
            flyToWorkTicketInfo={flyToWorkTicketInfo}
            setFlyToWorkTicketInfo={setFlyToWorkTicketInfo}
            isOSFieldDisabledNoTravelNeeded={isOSFieldDisabledNoTravelNeeded}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: '1%' }}>
        <Col>
          <Form.Check
            inline
            label="GreenLight"
            name="isGreenLighted"
            type="checkbox"
            id="isGreenLight_checkbox"
            value="isGreenLighted"
            checked={parseBooleanOrNull(flyToWorkTicketInfo.isGreenLighted)}
            onChange={(e) => handleUpdateFlightTicketInfo('isGreenLighted', e.target.checked)}
            disabled={isGreenLightCheckBoxDisabled()}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: '1%' }}>
        <Col style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Form.Label style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>Staff Luggage</Form.Label>
          <div style={{ flex: 1 }}>
            <Select
              options={mappedStaffLuggage}
              isSearchable
              isClearable
              onChange={(option) => {
                handleUpdateFlightTicketInfo('staffLuggage', option ? option.value : null);
              }}
              value={
                mappedStaffLuggage.find(
                  (x) => x.value === flyToWorkTicketInfo.staffLuggage || x.value === flyToWorkTicketInfo.luggage
                ) || null
              }
              isDisabled={isArrivalDepartureAirportDisabled()}
              styles={getReactSelectStyles(darkMode)}
            />
          </div>
        </Col>
      </Row>
    </Form.Group>
  </Row>
);

AdditionalOptionsSection.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
  setFlyToWorkTicketInfo: PropTypes.func.isRequired,
  mappedStaffLuggage: PropTypes.array.isRequired,
  handleUpdateFlightTicketInfo: PropTypes.func.isRequired,
  isOSFieldDisabled: PropTypes.func.isRequired,
  isOSFieldDisabledNoTravelNeeded: PropTypes.func.isRequired,
  isArrivalDepartureAirportDisabled: PropTypes.func.isRequired,
  isGreenLightCheckBoxDisabled: PropTypes.func.isRequired,
  darkMode: PropTypes.bool.isRequired,
  getReactSelectStyles: PropTypes.func.isRequired,
};

export default React.memo(AdditionalOptionsSection);
